<!--客户回访组件-->
<template>
    <el-dialog title="填写回访记录" :visible.sync="isShow" :before-close="handleClose">

        <el-form :model="form" ref="form" :rules="rules">

            <el-form-item v-if="customer" label="回访客户" :label-width="formLabelWidth">
                {{customer.name}}
            </el-form-item>

            <el-form-item label="回访对象" prop="contact_id" :label-width="formLabelWidth">
                <el-select v-model="form.contact_id" placeholder="请选择联系人" size="small">
                    <el-option v-for="contact in contacts" :key="contact.id" :label="contact.name" :value="contact.id">
                    </el-option>
                </el-select>
            </el-form-item>

            <el-form-item label="回访类型" prop="type" :label-width="formLabelWidth">
                <el-radio-group v-model="form.type">
                    <el-radio v-for="(type, index) in types" :label="index" :key="index" > {{type}}</el-radio>
                </el-radio-group>
            </el-form-item>

            <el-form-item label="回访方式" prop="method" :label-width="formLabelWidth">
                <el-select v-model="form.method" placeholder="请选择回访方式">
                    <el-option v-for="(method, index) in methods" :key="index" :label="method" :value="index">
                    </el-option>
                </el-select>
            </el-form-item>

            <el-form-item label="回访状态" prop="status" :label-width="formLabelWidth">
                <el-select v-model="form.status" placeholder="请选择回访状态">
                    <el-option v-for="(state, index) in status" :key="index" :label="state" :value="index">
                    </el-option>
                </el-select>
            </el-form-item>

            <el-form-item label="回访内容" prop="content" :label-width="formLabelWidth">
                <el-input type="textarea" placeholder="请填写回访内容" :rows="5" v-model="form.content"
                          auto-complete="off"></el-input>
            </el-form-item>

            <el-form-item v-show="displayProducts" label="问题类型" prop="category" :label-width="formLabelWidth">
                <el-select v-model="form.category" placeholder="请选择问题类型">
                    <el-option v-for="(category, index) in categories" :key="index" :label="category" :value="index">
                    </el-option>
                </el-select>
            </el-form-item>

            <el-form-item v-show="displayProducts" label="是否发送报告" prop="is_send" :label-width="formLabelWidth">
                <el-radio-group v-model="form.is_send">
                    <el-radio :label="0">否</el-radio>
                    <el-radio :label="1">是</el-radio>
                </el-radio-group>
            </el-form-item>

            <el-form-item v-show="form.is_send" label="接收报告邮箱" prop="email" :label-width="formLabelWidth">
                <el-input v-model="form.email" placeholder="请填写接收报告的邮箱"></el-input>
            </el-form-item>


            <el-form-item v-show="products && displayProducts" label="调研产品" prop="products" :label-width="formLabelWidth">
                <el-checkbox-group v-model="form.products" class="product-use" >
                    <el-checkbox v-for="product in products" :label="product.id" :key="product.id">{{product.name}}</el-checkbox>
                </el-checkbox-group>
            </el-form-item>

            <el-form-item label="下次回访时间" prop="next_time" :label-width="formLabelWidth">
                <el-date-picker
                        v-model="form.next_time"
                        type="date"
                        placeholder="选择日期">
                </el-date-picker>
            </el-form-item>

            <el-form-item label="业务员评价" prop="sales_rate" :label-width="formLabelWidth">
                <el-radio-group v-model="form.sales_rate">
                    <el-radio v-for="(rate, key) in rates" :label="key" :key="key">{{rate}}</el-radio>
                </el-radio-group>
            </el-form-item>


        </el-form>

        <div slot="footer" class="dialog-footer">
            <el-button @click="handleClose">取 消</el-button>
            <el-button :loading="loading" type="primary" @click="submitForm">确 定</el-button>
        </div>

    </el-dialog>
</template>

<script>
    import {CustomerVisit, VisitService, STATUS_INVALID} from "~/services/CustomerVisit";
    import ProductService from "~/services/product";
    import CustomerService from "~/services/customer";

    export default {
        name: "VisitModal",
        components: {},
        props: {

            // 是否显示当前对话框
            showDialog: {
                type: Boolean,
                required: true
            },

            // 外部传入的客户ID
            customerId: {
                type: Number,
                default: 0
            },

            // 是否开启回调，开启后表单填入的数据会回传给上层组件
            // 由上层处理数据的提交入库
            enableCallback: {
                type: Boolean,
                default: false,
            },

            // 当数据需要由上层处理时由上层来告诉当前组件是否完成了操作
            isFinished: {
                type: Boolean,
                default: false,
            }
        },
        data() {
            return {
                products: [],
                contacts: [],
                customer: {},
                types: VisitService.getTypes(), // 回访类型
                methods: VisitService.getMethods(), // 回访方式
                status: VisitService.getStatus(), // 回访状态
                rates: VisitService.getRates(), // 业务员评价类型
                categories: {}, // 回访问题类型
                form: CustomerVisit,
                formLabelWidth: "120px",
                isShow: false,
                loading: false,

                displayProducts: true,

                rules: {
                    contact_id: [
                        {
                            required: true,
                            message: "联系人不能为空"
                        },
                        {
                            type: "number"
                        }
                    ],
                    type : [
                        {
                            required: true,
                            message: "回访类型不能为空"
                        }
                    ],
                    method : [
                        {
                            required: true,
                            message: "回访方式不能为空"
                        }
                    ],
                    status: [
                        {
                            required: true,
                            message: "回访状态不能为空"
                        }
                    ],
                    category: [
                        {
                            required: true,
                            message: "问题类型不能为空"
                        }
                    ],
                    is_send: [
                        {
                            required: true,
                            message: "报告发送状态不能为空"
                        }
                    ],
                    products: [
                        {
                            required: true,
                            message: "调研产品不能为空"
                        }
                    ],
                    content: [
                        {
                            required: true,
                            message: "请输入跟进内容"
                        }
                    ],
                }
            };
        },
        created: function () {
            if (this.products.length == 0) {
                this.getProducts();
            }

            // 此处在将当前组件嵌套至第三层时 customerId 有根据外部传入改变
            // 但是 watch 没能监听到 所以这里临时打个补丁
            if (!this.customer.name && this.customerId > 0) {
                let CustomerId = this.customerId;
                this.getCustomer(CustomerId);
                this.getContacts(CustomerId);
                this.form.customer_id = CustomerId;
            }

        },
        watch: {
            // 监听属性 showDialog
            showDialog: function (value, original) {
                this.isShow = value;
                // 窗口一弹出就去异步获取
                this.getCategories();
            },

            // 监听属性 customerId
            customerId: function (value, original) {
                if (parseInt(value) > 0) {
                    this.getCustomer(value);
                    this.getContacts(value);
                    this.form.customer_id = value;
                }
            },

            isFinished: function (value, original) {
                if (value == true) {
                    this.loading = false;
                    this.close();
                }
            },

            'form.status': function (value, original) {
                if (value == STATUS_INVALID) {
                    this.displayProducts = false;
                } else {
                    this.displayProducts = true;
                }
            },

            displayProducts: function (value, original) {
                this.rules.category[0].required = value;
                this.rules.is_send[0].required = value;
                this.rules.products[0].required = value;
            }
        },
        methods: {

            // 通过 CustomerId 获取客户信息
            getCustomer(customerId) {
                CustomerService.getInfo(customerId).then(res => {
                    if (res && res.data) {
                        this.customer = res.data;
                    }
                }).catch(error => {
                    console.error(error);
                })
            },

            // 得到产品列表
            getProducts() {
                ProductService.getOptionList()
                    .then(res => {
                        if (res && res.data) {
                            this.products = res.data;
                        }
                    })
                    .catch(error => {
                        console.error(error);
                    });
            },

            // 得到客户的联系人列表
            getContacts(customerId) {
                CustomerService.getContacts(customerId).then(res => {
                    if (res && res.data) {
                        this.contacts = res.data;
                    }
                }).catch(error => {
                    console.error(error);
                });
            },

            getCategories() {
                VisitService.getQuestionCategories().then(res => {
                    if (res && res.data) {
                        this.categories = res.data;
                    }
                }).catch(err => {
                    console.log(err);
                })
            },

            // 关闭窗口
            handleClose(done) {
                this.$confirm("陛下你还没有保存内容，确认要关闭窗口？", "温馨提示", {type: "warning"}).then(ok => {
                    this.close();
                }).catch(cancel => {
                    return false;
                });
            },

            // 处理用户选择
            handleUserSelect(UserId) {
                this.form.executor_id = UserId;
            },

            // 关闭当前窗口
            close() {
                this.isShow = false;
                // 往上层组件传递更改后的状态
                this.$emit("closeModal", this.isShow);
                this.displayProducts = true;
            },

            // 提交表单
            submitForm() {
                this.$refs["form"].validate(valid => {
                    if (valid) {
                        this.loading = true;
                        if (this.enableCallback == true) {
                            // 直接将数据通过事件回传给上层数据处理
                            this.$emit("traceCallBack", this.form);
                            return;
                        } else {
                            // 直接提交跟进记录入库
                            VisitService.create(this.form).then(res => {
                                this.loading = false;
                                if (res && res.code == 0) {
                                    this.$message({type: "success", message: "执行成功!"});
                                    this.close();
                                    this.$refs["form"].resetFields();
                                    this.$emit("saveCallback", res.data)
                                }
                            }).catch(err => {
                                this.loading = false;
                                console.error(err);
                            })
                        }
                    } else {
                        return;
                    }
                });
            }
        }
    };
</script>



// WEBPACK FOOTER //
// src/views/tasks/VisitModal.vue